module.exports = __webpack_public_path__ + "static/media/10.84371131.png";